import { useContext } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../userContext/userContext";

export default function useLogout() {
  const { userDispatch } = useContext(UserContext);
  const history = useHistory();

  return (event) => {
    event.preventDefault();
    sessionStorage.removeItem("jwttoken");
    sessionStorage.removeItem("isLogged");
    ["firstName", "lastName", "last_name", "role", "_id"].forEach((key) => {
      localStorage.removeItem(key);
    });
    delete axios.defaults.headers.common.jwtToken;
    userDispatch({ type: "LOGOUT" });
    // Keep the loaded application and styles when returning to the public home.
    history.replace("/");
  };
}
